<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M15.3185 7.6001H9.00464C8.22974 7.6001 7.60156 8.22828 7.60156 9.00317V15.317C7.60156 16.0919 8.22974 16.7201 9.00464 16.7201H15.3185C16.0934 16.7201 16.7216 16.0919 16.7216 15.317V9.00317C16.7216 8.22828 16.0934 7.6001 15.3185 7.6001Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.38587 11.3998H3.68433C3.31221 11.3998 2.95533 11.252 2.6922 10.9888C2.42907 10.7257 2.28125 10.3688 2.28125 9.99671V3.68286C2.28125 3.31074 2.42907 2.95386 2.6922 2.69074C2.95533 2.42761 3.31221 2.27979 3.68433 2.27979H9.99817C10.3703 2.27979 10.7272 2.42761 10.9903 2.69074C11.2534 2.95386 11.4012 3.31074 11.4012 3.68286V4.3844"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
